const state = () => ({
  settings: {},
});

const getters = {};

const actions = {};

const mutations = {
  updateGlobalSettings(state, val) {
    state.settings = val;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
